module.exports = __webpack_public_path__ + "img/graph2.62da0651.png";